module.exports = __webpack_public_path__ + "static/media/bomberman-2.3bf2ac49.gif";